/* eslint-disable global-require */
export default {
  AbsenteeDeadlines: require('./AbsenteeDeadlines').default,
  AbsenteeMailBallotIssues: require('./AbsenteeMailBallotIssues').default,
  AbsenteeRequestMethods: require('./AbsenteeRequestMethods').default,
  BallotCuring: require('./BallotCuring').default,
  BallotReturnMethods: require('./BallotReturnMethods').default,
  BallotTracker: require('./BallotTracker').default,
  default: require('./default').default,
  EarlyVotingCalendar: require('./EarlyVotingCalendar').default,
  ElectionDeadlines: require('./ElectionDeadlines').default,
  EmergencyAbsenteeBallots: require('./EmergencyAbsenteeBallots').default,
  Forms: require('./Forms').default,
  OnlineVoterRegistration: require('./OnlineVoterRegistration').default,
  PermanentAbsenteeVoting: require('./PermanentAbsenteeVoting').default,
  PreRegistration: require('./PreRegistration').default,
  ProvisionalBallotTracker: require('./ProvisionalBallotTracker').default,
  RegistrationDeadlines: require('./RegistrationDeadlines').default,
  SameDayRegistration: require('./SameDayRegistration').default,
  StatePollingPlaceLocator: require('./StatePollingPlaceLocator').default,
  VBMRules: require('./VBMRules').default,
  VoterIDLawsAbsentee: require('./VoterIdLawsAbsentee').default,
  VoterIDLawsInPerson: require('./VoterIDLawsInPerson').default,
  VoterIDLawsRegistration: require('./VoterIDLawsRegistration').default,
  VoterRegistrationMethods: require('./VoterRegistrationMethods').default,
  VotingRightsRestoration: require('./VotingRightsRestoration').default,
  WaysToVote: require('./WaysToVote').default,
};
